import './App.scss';
import Home from './components/Home/Home';

function App() {
  console.log('Design inspired by Brittany Chiang\'s portfolio at https://brittanychiang.com.');

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;